import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Divider } from 'antd';
import { ReactComponent as EdgelIcon } from '../../../../../assets/icons/edge.svg';
import { ReactComponent as GreyPoint } from '../../../../../assets/icons/graphGreyPoint.svg';
import { ReactComponent as BluePoint } from '../../../../../assets/icons/graphBluePoint.svg';
import { ReactComponent as DarkBluePoint } from '../../../../../assets/icons/graphDarkBluePoint.svg';
import { ReactComponent as PurplePoint } from '../../../../../assets/icons/graphPurplePoint.svg';
import { ReactComponent as BlueEdge } from '../../../../../assets/icons/graphBlueEdge.svg';
import { ReactComponent as GreyEdge } from '../../../../../assets/icons/graphGreyEdge.svg';
import { ReactComponent as PurpleEdge } from '../../../../../assets/icons/graphPurpluEdge.svg';
import reject_icon from '../../../../../assets/icons/reject_icon.png';
import return_icon from '../../../../../assets/icons/return_icon.png';
import cross_icon from '../../../../../assets/icons/cross_icon.png';
import check_icon from '../../../../../assets/icons/check_icon.png';
import { StatusTag } from 'components';

const Graph = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);
  const businessKey = apptrackDetails?.businessKey;
  const activeTaskName = apptrackDetails?.activeTaskName;

  return (
    <>
      <Row gutter={32} className="diagram-container">
        {/* style={{ paddingBottom: '5.4rem' }} */}
        <Col span={24}>{/* <Divider className="top" /> */}</Col>

        <Col span={24} className="main-flow-nodes">
          <div className="point-svg">
            {activeTaskName === 'task.name.submit_application' ? (
              <DarkBluePoint className="point-svg" />
            ) : (
              <BluePoint className="point-svg" />
            )}
            <div className="extra-nodes">
              <div className="extra-dashed-edge"></div>
              <div
                className={
                  // "active-completion-node"
                  activeTaskName === 'task.name.submit_application'
                    ? 'darkBlue-node first node-item'
                    : 'lightBlue-node first node-item'
                }
              >
                <span>Σε Επεξεργασία Αίτησης</span>
              </div>
            </div>
          </div>
          {activeTaskName === 'task.name.submit_application' ? (
            <GreyEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-8rem' }}
            />
          ) : (
            <BlueEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-8rem' }}
            />
          )}
          <div className="point-svg-2">
            <div
              className={
                // "active-completion-node"
                activeTaskName === 'task.name.application_evaluation'
                  ? 'darkBlue-node second node-item'
                  : activeTaskName === 'task.name.application_evaluated' ||
                      activeTaskName === 'task.name.complete'
                    ? 'lightBlue-node second node-item'
                    : 'grey-node second node-item'
              }
            >
              <span>Center of Excellence</span>
            </div>
            <div className="extra-nodes-2">
              <div className="extra-dashed-edge-2"></div>
            </div>
            {activeTaskName === 'task.name.application_evaluation' ? (
              <BluePoint className="point-svg" />
            ) : activeTaskName === 'task.name.submit_application' ? (
              <GreyPoint className="point-svg" />
            ) : (
              <BluePoint className="point-svg" />
            )}
          </div>
          {activeTaskName === 'task.name.submit_application' ||
          activeTaskName === 'task.name.application_evaluation' ? (
            <GreyEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-7rem' }}
            />
          ) : (
            <BlueEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-4rem' }}
            />
          )}
          <div className="point-svg" style={{ marginLeft: '-6rem' }}>
            {activeTaskName === 'task.name.application_evaluated' ? (
              <DarkBluePoint className="point-svg" />
            ) : activeTaskName === 'task.name.complete' ? (
              <BluePoint className="point-svg" />
            ) : (
              <GreyPoint className="point-svg" />
            )}
            <div className="extra-nodes">
              <div className="extra-dashed-edge"></div>
              <div
                className={
                  // "active-completion-node"
                  activeTaskName === 'task.name.application_evaluated'
                    ? 'darkBlue-node third node-item'
                    : activeTaskName === 'task.name.complete'
                      ? 'lightBlue-node third'
                      : 'grey-node third node-item'
                }
              >
                <span>Υποβολή Αίτησης</span>
              </div>
            </div>
          </div>
          {activeTaskName === 'task.name.complete' ? (
            <PurpleEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-7rem' }}
            />
          ) : (
            <GreyEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-7rem' }}
            />
          )}
          <div className="point-svg-2">
            <div
              className={
                // "active-completion-node"
                activeTaskName === 'task.name.complete'
                  ? 'purple-node fourth node-item'
                  : 'grey-node fourth node-item'
              }
            >
              {activeTaskName === 'task.name.complete' ? (
                <a
                  href="https://greece20-loans.gov.gr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-underline">Go Beyond Loans</span>
                </a>
              ) : (
                <span>Go Beyond Loans</span>
              )}
            </div>
            <div className="extra-nodes-2">
              <div className="extra-dashed-edge-2"></div>
            </div>
            {activeTaskName === 'task.name.complete' ? (
              <PurplePoint className="point-svg" />
            ) : (
              <GreyPoint className="point-svg" />
            )}
          </div>
        </Col>
      </Row>

      <Row gutter={32}>
        <Col span={24} style={{ height: 56 }}></Col>
      </Row>
    </>
  );
};

export default Graph;
